// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const SavedSearchesToggle = () => ({
   replace: true,
   templateUrl: '/assets/savedSearchesToggle.html',
   controller: 'SavedSearchCtrl'
})

const SavedSearchesDialog = () => ({
   replace: true,
   templateUrl: '/assets/savedSearchesDialog.html',
   controller: 'SavedSearchCtrl'
})

const SaveSearchHelp = (HelpLinks:any ,i18n: TranslationService) => ({
   replace: true,
   templateUrl: '/assets/saveSearchHelp.html',
   scope: {
      helpLinkKey: '@' // Use '@' for one-way binding
   },
   link(scope: any) {
      scope.helpLink = HelpLinks[scope.helpLinkKey]
      scope.i18n = i18n
   }
})

angular.module('summonApp.directives')
   .directive('savedSearchesToggle', SavedSearchesToggle)
   .directive('savedSearchesDialog',['$helpLinks',SavedSearchesDialog])
   .directive('saveSearchHelp', ['$helpLinks','translationService' , SaveSearchHelp])
